export default "__VITE_ASSET__ebdf1102__"